import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';

import visbook from 'api/visbook';
import { setOrderGroupData } from 'store';
import NotFoundError from 'views/SummaryPage/NotFoundError';
import Summary from 'views/SummaryPage/Summary';

class SummaryPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            running: true,
            error: false,
        }
    }

    componentDidMount() {
        const queryParams = queryString.parse(this.props.location.search);

        // Only enable test data locally.
        if(process.env.NODE_ENV === 'development') {
            this.props.setOrderGroupData(
              {
                  id: 3823519,
                  registrationDate: '2020-05-15T10:16:05',
                  currency: {
                      id: 3,
                      name: 'NOK'
                  },
                  encryptedBookingCompanyId: 'FAAUAAUADwAHAAAAAAAAAFMTZypwbyJXa46VdA7Ixr4%3D',
                  encryptedCompanyId: 'FAAUAAUADwAHAAAAAAAAAFMTZypwbyJXa46VdA7Ixr4%3D',
                  cancellationRules: null,
                  orders: [
                      {
                          bookings: [
                              {
                                  id: 586482,
                                  standardName: 'The Vault | Standard  Room ',
                                  name: 'The Vault | Standard  Room',
                                  notes: null,
                                  numberOfPeople: 1,
                                  count: 1,
                                  total: 1,
                                  price: 1,
                                  unitType: 'none',
                                  status: 'paid',
                                  type: 'accommodation',
                                  fromDate: '2025-05-12T00:00:00',
                                  toDate: '2025-05-13T00:00:00',
                                  subBookings: [],
                                  people: []
                              },
                              {
                                  id: 586483,
                                  standardName: 'The Vault | Standard  Room ',
                                  name: 'The Vault | Standard  Room',
                                  notes: null,
                                  numberOfPeople: 1,
                                  count: 1,
                                  total: 1,
                                  price: 1,
                                  unitType: 'none',
                                  status: 'paid',
                                  type: 'accommodation',
                                  fromDate: '2025-05-12T00:00:00',
                                  toDate: '2025-05-13T00:00:00',
                                  subBookings: [],
                                  people: []
                              },
                              {
                                  id: 586484,
                                  standardName: '          Polfareren | Standard Room',
                                  name: 'Polfareren | Standard Room',
                                  notes: null,
                                  numberOfPeople: 1,
                                  count: 1,
                                  total: 1,
                                  price: 1,
                                  unitType: 'none',
                                  status: 'paid',
                                  type: 'accommodation',
                                  fromDate: '2025-05-12T00:00:00',
                                  toDate: '2025-05-13T00:00:00',
                                  subBookings: [],
                                  people: []
                              },
                              {
                                  id: 586485,
                                  standardName: 'The Vault | Standard  Room ',
                                  name: 'The Vault | Standard  Room',
                                  notes: null,
                                  numberOfPeople: 1,
                                  count: 1,
                                  total: 1,
                                  price: 1,
                                  unitType: 'none',
                                  status: 'paid',
                                  type: 'accommodation',
                                  fromDate: '2025-05-12T00:00:00',
                                  toDate: '2025-05-13T00:00:00',
                                  subBookings: [],
                                  people: []
                              }
                          ],
                          bookingsCount: 4,
                          orderTotalPrice: 4,
                          orderTotalPaid: 4,
                          encryptedCompanyId: 'FAAUAAUADwAHAAAAAAAAAFMTZypwbyJXa46VdA7Ixr4%3D',
                          pdfsEndpoint: 'https://ws.visbook.com/api/8/325/pdf/FAAUAAUADwAHAAAAAAAAAFMTZypwbyJXa46VdA7Ixr4%3D/80007',
                          id: 80007,
                          orderedAt: '2020-05-15T10:16:05',
                          lastChangedAt: '2020-05-15T10:16:07',
                          cancelledAt: '0001-01-01T00:00:00',
                          from: '2025-05-12T00:00:00',
                          to: '2025-05-13T00:00:00',
                          status: 'paid'
                      }
                  ]
              }
            );
        }

        this.setState({running: false})

        if(!queryParams.orderGroupId) {
            // Only redirect in prod/stage
            if(process.env.NODE_ENV === 'production') {
                this.props.history.push('/');
            }

        } else {
            visbook.loadOrderGroupData(queryParams.orderGroupId)
                .then(r => {
                    this.props.setOrderGroupData(r.data);
                    this.setState({
                        running: false,
                    });
                })
                .catch(r => {
                    this.setState({
                        running: false,
                        error: true,
                    });
                })
        }
    }

    render() {
        const { error, running } = this.state;
        const { orderGroupData, customer } = this.props.booking;

        if(running) return null;

        if(error) {
            return <NotFoundError/>
        }

        return <Summary orderGroupData={ orderGroupData } customer={ customer }/>
    }
}

const mapStateToProps = state => {
    return {
        booking: state.booking,
    }
}

const actions = {
    setOrderGroupData,
}

export default connect(mapStateToProps, actions)(withRouter(SummaryPage));